import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
    error: null
};

const slice = createSlice({
    name: "error",
    initialState,
    reducers: {
        setError(state, action) {
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    setError,
    clearError
} = slice.actions;
